import { SegmentedControl, Stack, Switch, Text } from "@mantine/core";
import type { AssistantWaitSoundText } from "@/locales/assistant-wait-sound";
import {
	isWaitSoundVolume,
	WAIT_SOUND_VOLUMES,
	type WaitSoundVolume,
} from "@/types/ai-assistant-style";

interface Props {
	t: AssistantWaitSoundText;
	enabled: boolean;
	volume: WaitSoundVolume;
	disabled: boolean;
	onEnabledChange: (enabled: boolean) => void;
	onVolumeChange: (volume: WaitSoundVolume) => void;
}

/** Nyala/mati + volume bunyi tunggu napas mode suara (#60). */
export function StyleWaitSound({
	t,
	enabled,
	volume,
	disabled,
	onEnabledChange,
	onVolumeChange,
}: Props) {
	return (
		<Stack gap="xs" data-wait-sound>
			<Text fw={600}>{t.title}</Text>
			<Text size="sm" c="dimmed">
				{t.description}
			</Text>
			<Switch
				label={t.enabled}
				checked={enabled}
				disabled={disabled}
				onChange={(e) => onEnabledChange(e.currentTarget.checked)}
				data-wait-sound-enabled
			/>
			<Stack gap={4}>
				<Text size="sm" fw={500}>
					{t.volume}
				</Text>
				<SegmentedControl
					value={volume}
					disabled={disabled || !enabled}
					onChange={(v) => {
						if (isWaitSoundVolume(v)) onVolumeChange(v);
					}}
					data={WAIT_SOUND_VOLUMES.map((v) => ({
						value: v,
						label: t.volumes[v],
					}))}
					data-wait-sound-volume
				/>
			</Stack>
		</Stack>
	);
}
